import "./categoryBlock.css";

export const CategoryBlock = ({
  serviceCategory,
  setSelectedCategory,
  selectedCategoryID,
}) => {
  const isSelected = serviceCategory.id === selectedCategoryID;
  return (
    <button
      type="button"
      className={
        isSelected ? "categoryBlock categoryBlockSelected" : "categoryBlock"
      }
      aria-pressed={isSelected}
      onClick={() => setSelectedCategory(serviceCategory)}
    >
      <span>
        {" "}
        {serviceCategory.title ? serviceCategory.title : serviceCategory.header}
      </span>
    </button>
  );
};
